<template>
    <img alt="image" class="rounded-circle" :width="width" :src="getBlockie(address)"/>
</template>

<script>
    import blockies from "ethereum-blockies";
    import makeBlockie from 'ethereum-blockies-base64';

    export default {
        name: "Blockie",
        props: {
            width: {
                type: Number,
                default: 32
            },
            address: {
                type: String
            }
        },
        methods: {
            getBlockie(seed) {
                // let icon = blockies.create({
                //     seed: seed,
                //     color: '#dfe',
                //     bgcolor: '#019b40',
                //     size: 10,
                //     scale: 8,
                //     spotcolor: '#444'
                // });
                // return icon.toDataURL();

                return makeBlockie(seed);
            }
        }
    }
</script>

<style scoped>

</style>